module.exports = __webpack_public_path__ + "img/info-big-icon.80b4e081.svg";